import _ from "lodash";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";

function getActorName(activity) {
    if (activity.actor === "user") {
        return _.get(activity, "actorUser.name");
    } else if (activity.actor === "visitor") {
        return _.get(activity, "refVisitor.fullname");
    } else if (activity.actor === "chatbot") {
        return "Chatbot";
    } else if (activity.actor === "system") {
        return "System";
    }
}

function getChannelNameByType(type) {
    return (
        {
            "whatsapp-business-api": " Whatsapp Business API",
            telegram: "Telegram",
            "whatsapp-qr": "Whatsapp V1",
            "whatsapp-v2": "Whatsapp V2",
            "sms-postacell": "SMS Postacell",
            openai: "OpenAI",
            ideasoft: "Ideasoft",
            ticimax: "Ticimax",
            messenger: "Messenger",
            instagram: "Instagram",
        }[type.payload.type] || type
    );
}

function planCanceled(activity) {
    if (this.$_.get(this.activity, "payload.details")) {
        return this.$t("notification.planCanceledAgent", {
            user: getActorName(activity),
            title: this.$_.get(this.activity, "payload.title"),
            altTitle: this.$_.get(this.activity, "payload.altTitle"),
            details: this.$_.get(this.activity, "payload.details"),
        });
    } else if (this.$_.get(this.activity, "payload.detailsChatbot")) {
        return this.$t("notification.planCanceledChatbot", {
            user: this.$_.get(this.activity, "actorUser.name"),
            title: this.$_.get(this.activity, "payload.title"),
            altTitle: this.$_.get(this.activity, "payload.altTitle"),
            chatbot: this.$_.get(this.activity, "payload.detailsChatbot"),
        });
    } else if (this.$_.get(this.activity, "payload.detailsWp")) {
        return this.$t("notification.planCanceledWhatsapp", {
            user: this.$_.get(this.activity, "actorUser.name"),
            title: this.$_.get(this.activity, "payload.title"),
            altTitle: this.$_.get(this.activity, "payload.altTitle"),
            whatsapp: this.$_.get(this.activity, "payload.detailsWp"),
        });
    } else if (this.$_.get(this.activity, "payload.detailWpApi")) {
        return this.$t("notification.planCanceledWhatsappApi", {
            user: this.$_.get(this.activity, "actorUser.name"),
            title: this.$_.get(this.activity, "payload.title"),
            altTitle: this.$_.get(this.activity, "payload.altTitle"),
            whatsappApi: this.$_.get(this.activity, "payload.detailWpApi"),
        });
    }
}

const settingPageChange = (name, that) => {
    that.$router.push(`/settings/${name}`);
    SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.SETTINGS_PAGE_CHANGED, {
        name,
    });
};

const ActivityTypes = {
    BLOCK_VISITOR: {
        id: "blocked",
        icon: "assignment_ind",
        message: (activity, that) =>
            that.$t("notification.visitorBlocked", {
                visitor: that.$_.get(activity, "refVisitor.fullname"),
                agent: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },
    UNBLOCK_VISITOR: {
        id: "unblocked",
        icon: "block",
        message: (activity, that) =>
            that.$t("notification.visitorUnblocked", {
                visitor: that.$_.get(activity, "payload.fullname"),
                agent: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },
    CHAT_OPENED: {
        id: "chat-opened",
        icon: "open_in_new",
        message: (activity) => {
            if (activity.actor === "visitor") {
                return `${_.get(activity, "refVisitor.fullname")} started ${_.get(activity, "payload.ref")} chat`;
            } else if (activity.actor === "user") {
                return `${_.get(activity, "payload.ref")} Chat started with ${_.get(
                    activity,
                    "refVisitor.fullname"
                )} by ${_.get(activity, "actorUser.name")}`;
            } else {
                return "";
            }
        },
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },

    CHAT_CLOSED: {
        id: "chat-closed",
        icon: "closed_caption_disabled",
        message: (activity, that) =>
            // ${getActorName(activity)}
            that.$t("notification.chatClosed", {
                visitor: that.$_.get(activity, "refVisitor.fullname"),
                agent: getActorName(activity),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },
    //bu kısma geri dönülecek uı da gösterim komponenti mevcut değil
    CHAT_RATING: {
        id: "chat-rating",
        icon: "reviews",
        message: (activity) => `Chata puan verildi`,
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },
    CHAT_ASSIGNED_TO_USER: {
        id: "chat-assigned-to-user",
        icon: "event_seat",
        message: (activity, that) =>
            that.$t("notification.chatAssigned", {
                visitor: that.$_.get(activity, "payload.fullname"),
                agent: that.$_.get(activity, "payload.joinedUserName"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },
    CHAT_FORWARDED_TO_USER: {
        id: "chat-forwarded-to-user",
        icon: "mark_chat_read",
        // getActorName(activity)
        message: (activity, that) =>
            that.$t("notification.chatForwarded", {
                visitor: that.$_.get(activity, "payload.fullname"),
                agent: that.$_.get(activity, "payload.joinedUserName"),
                user: getActorName(activity),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },

    USER_JOINED_TO_CHAT: {
        id: "user-joined-to-chat",
        icon: "headset_mic",
        message: (activity, that) =>
            that.$t("notification.chatJoined", {
                agent: getActorName(activity),
                visitor: that.$_.get(activity, "payload.fullname"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },

    // bu kısma geri dönülücek uı komponenti mevcut değil
    VISITOR_ONLINE: {
        id: "online",
        icon: "online_prediction",
        message: (activity) => `Ziyaretci Online Oldu`,
        onClick: (activity, that) => {
            that.$router.push("/visitors");
        },
    },
    // bu kısma geri dönülcek
    VISITOR_OFFLINE: {
        id: "offline",
        icon: "offline_bolt",
        message: (activity) => `Ziyaretci Offline Oldu`,
        onClick: (activity, that) => {
            that.$router.push("/visitors");
        },
    },
    // bu kısma geri dönülcek
    PAGE_CHANGED: {
        id: "page-changed",
        icon: "pageview",
        message: (activity) => `Sayfa Değiştirildi`,
        onClick: (activity, that) => {
            that.$router.push("/visitors");
        },
    },
    // bu kısma geri dönülecek
    VISITOR_CREATE_TICKET: {
        id: "create-ticket",
        icon: "confirmation_number",
        message: (activity) => `Ziyaretçi tarafından Ticket Eklendi`,
        onClick: (activity, that) => {
            that.$router.push("/ticket");
        },
    },
    // bu kısma geri dönülcek
    VIDEO_CALLING_STARTED: {
        id: "video-calling-started",
        icon: "videocam",
        message: (activity) => `Görüntülü Arama Başlatıldı`,
        onClick: (activity, that) => {
            that.$router.push("/archives");
        },
    },
    // bu kısma geri dönülcek
    VIDEO_CALLING_CLOSED: {
        id: "video-calling-closed",
        icon: "videocam_off",
        message: (activity) => `Görüntülü Arama Kapatıldı`,
        onClick: (activity, that) => {
            that.$router.push("/archives");
        },
    },
    // bu kısma geri dönülcek
    VOICE_CALLING_STARTED: {
        id: "voice-calling-started",
        icon: "support_agent",
        message: (activity) => `Sesli Arama Başlatıldı`,
        onClick: (activity, that) => {
            that.$router.push("/archives");
        },
    },
    // bu kısma geri dönülcek
    VOICE_CALLING_CLOSED: {
        id: "voice-calling-closed",
        icon: "phone_callback",
        message: (activity) => `Sesli Arama Kapatıldı`,
        onClick: (activity, that) => {
            that.$router.push("/archives");
        },
    },
    // bu kısma geri dönülecek
    VISITOR_TAG_ADDED: {
        id: "visitor-tag-added",
        icon: "local_offer",
        message: (activity) => `Ziyaretciye Etiket Eklendi`,
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },
    // bu kısma geri dönülecek
    VISITOR_TAG_REMOVED: {
        id: "visitor-tag-removed",
        icon: "local_offer",
        message: (activity) => `Ziyaretçiden Etiket Kaldırıldı`,
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },

    // bu kısma geri dönülecek
    NOTE_CREATED: {
        id: "note-created",
        icon: "edit_note",
        message: (activity) => `Not Eklendi`,
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },
    // bu kısma geri dönülecek
    NOTE_UPDATED: {
        id: "note-updated",
        icon: "edit_note",
        message: (activity) => `Not Güncellendi`,
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },

    // bu kısma geri dönülecek
    VISITOR_PROFILE_UPDATED: {
        id: "visitor-profile-updated",
        icon: "account_circle",
        message: (activity) => `Ziyaretçi Profili Güncellendi`,
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },

    USER_ADDED: {
        id: "user-added",
        icon: "person_add",
        message: (activity, that) =>
            that.$t("notification.userAdded", {
                newAgent: that.$_.get(activity, "payload.name"),
                agent: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/users");
        },
    },
    USER_REMOVED: {
        id: "user-removed",
        icon: "assignment_ind",
        message: (activity, that) =>
            that.$t("notification.userRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                oldUser: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/users");
        },
    },
    USER_STATUS_CHANGED: {
        id: "user-status-changed",
        icon: "signal_wifi_statusbar_null",
        message: (activity, that) =>
            that.$t("notification.userStatusChanged", {
                name: that.$_.get(activity, "payload.name"),
                oldStatus: that.$_.get(activity, "payload.oldStatus"),
                newStatus: that.$_.get(activity, "payload.newStatus"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/users");
        },
    },
    USER_LOGGED_IN: {
        id: "user-logged-in",
        icon: "login",
        message: (activity, that) => that.$t("notification.userLoggenIn", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            that.$router.push("/users");
        },
    },
    USER_ADDED_TO_DEPARTMENT: {
        id: "user-added-to-department",
        icon: "local_fire_department",
        message: (activity, that) =>
            that.$t("notification.userAddedToDepartment", {
                user1: that.$_.get(activity, "actorUser.name"),
                user2: that.$_.get(activity, "payload.userName"),
                department: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/users");
        },
    },
    USER_REMOVED_FROM_DEPARTMENT: {
        id: "user-removed-from-depart",
        icon: "local_fire_department",
        message: (activity, that) =>
            that.$t("notification.userRemovedToDepartment", {
                user1: that.$_.get(activity, "actorUser.name"),
                user2: that.$_.get(activity, "payload.userName"),
                department: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/users");
        },
    },

    SETTINGS_UPDATED: {
        id: "settings-updated",
        icon: "settings",
        message: (activity, that) =>
            that.$t("notification.settingsUpdatedWoDetail", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/settings");
        },
    },

    WHATSAPP_BROADCAST_CREATED: {
        id: "whatsapp-broadcast-created",
        icon: "cell_tower",
        message: (activity, that) =>
            that.$t("notification.whatsappBroadcastCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                title: that.$_.get(activity, "payload.title"),
                numbers: that.$_.get(activity, "payload.numbers"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WHATSAPP_BROADCAST_CANCELED: {
        id: "whatsapp-broadcast-canceled",
        icon: "cell_tower",
        message: (activity, that) =>
            that.$t("notification.whatsappBroadcastCancelled", { title: that.$_.get(activity, "payload.title") }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WHATSAPP_BROADCAST_COMPLETED: {
        id: "whatsapp-broadcast-completed",
        icon: "cell_tower",
        message: (activity, that) =>
            that.$t("notification.whatsappBroadcastCompleted", {
                title: that.$_.get(activity, "payload.title"),
                numbers: that.$_.get(activity, "payload.numbers"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WHATSAPP_BROADCAST_FAILED: {
        id: "whatsapp-broadcast-failed",
        icon: "cell_tower",
        message: (activity, that) =>
            that.$t("notification.whatsappBroadcastFailed", { title: that.$_.get(activity, "payload.title") }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WHATSAPP_V1_BOT_STATE_CHANGED: {
        id: "whatsapp-v1-bot-state-changed",
        icon: "qr_code_scanner",
        message: (activity) =>
            `${_.get(activity, "actor")}: ${_.get(activity, "payload.channelName")} state changed form ${_.get(
                activity,
                "payload.oldState"
            )} to ${_.get(activity, "payload.newState")}`,
    },
    WHATSAPP_V2_BOT_STATE_CHANGED: {
        id: "whatsapp-v2-bot-state-changed",
        icon: "qr_code_scanner",
        message: (activity) =>
            `${_.get(activity, "actor")}: ${_.get(activity, "payload.channelName")} state changed form ${_.get(
                activity,
                "payload.oldState"
            )} to ${_.get(activity, "payload.newState")}`,
    },

    CHANNEL_CREATED: {
        id: "channel-created",
        icon: "add_circle_outline",
        message: (activity, that) =>
            that.$t("notification.channelCreated", {
                name: that.$_.get(activity, "actorUser.name"),
                channel: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push(
                `/integrations/${_.get(activity, "payload.type")}/${_.get(activity, "payload._id")}/detail`
            );
        },
    },
    CHANNEL_REMOVED: {
        id: "channel-removed",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.channelRemoved", {
                channel: that.$_.get(activity, "payload.name"),
                agent: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    CHANNEL_VISIBILITY_CHANGED: {
        id: "channel-visibility-changed",
        icon: "visibility",
        message: (activity, that) =>
            that.$t("notification.channelVisibilityChanged", {
                channel: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },

    LOGIN_FORM_ACTIVATED: {
        id: "login-form-activated",
        icon: "list",
        message: (activity, that) =>
            that.$t("notification.loginFormActivated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            settingPageChange("visitor-login-form");
        },
    },
    LOGIN_FORM_DEACTIVATED: {
        id: "login-form-deactivated",
        icon: "list",
        message: (activity, that) =>
            that.$t("notification.loginFormDeactivated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            settingPageChange("visitor-login-form");
        },
    },
    LOGIN_FORM_UPDATED: {
        id: "login-form-updated",
        icon: "list",
        message: (activity, that) =>
            that.$t("notification.loginFormUpdated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            settingPageChange("visitor-login-form");
        },
    },

    CHATBOT_CREATED: {
        id: "chatbot-created",
        icon: "smart_toy",
        message: (activity, that) =>
            that.$t("notification.chatbotCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                chatbot: that.$_.get(activity, "payload.title"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chatbot/stories");
        },
    },
    CHATBOT_DELETED: {
        id: "chatbot-deleted",
        icon: "smart_toy",
        message: (activity, that) =>
            that.$t("notification.chatbotDeleted", {
                user: that.$_.get(activity, "actorUser.name"),
                chatbot: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chatbot/stories");
        },
    },
    CHATBOT_PUBLISHED: {
        id: "chatbot-published",
        icon: "smart_toy",
        message: (activity, that) =>
            that.$t("notification.chatbotPublished", {
                user: that.$_.get(activity, "actorUser.name"),
                version: that.$_.get(activity, "payload.version"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chatbot/stories");
        },
    },
    // bu kısma geri dönülecek
    CHATBOT_WEBHOOK_ADDED: {
        id: "chatbot-webhook-added",
        icon: "smart_toy",
        message: (activity) => `Chatbot webhook added`,
        onClick: (activity, that) => {
            that.$router.push("/chatbot/integrations/webhook");
        },
    },
    // bu kısma geri dönülücek
    CHATBOT_WEBHOOK_REMOVED: {
        id: "chatbot-webhook-removed",
        icon: "smart_toy",
        message: (activity) => `Chatbot webhook removed`,
        onClick: (activity, that) => {
            that.$router.push("/chatbot/integrations/webhook");
        },
    },

    BANNED_WORD_ADDED: {
        id: "banned-word-added",
        icon: "sync_lock",
        message: (activity, that) =>
            that.$t("notification.bannedWordCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                bWord: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/forbidden-inputs");
        },
    },
    BANNED_WORD_REMOVED: {
        id: "banned-word-removed",
        icon: "sync_lock",
        message: (activity, that) =>
            that.$t("notification.bannedWordRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                bWord: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/forbidden-inputs");
        },
    },

    // bu mail kısmına geri dönülecek
    MAIL_ADDRESS_ADDED: {
        id: "mail-address-added",
        icon: "email",
        message: (activity, that) =>
            that.$t("notification.mailAddressAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                email: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/mails");
        },
    },
    MAIL_ADDRESS_REMOVED: {
        id: "mail-address-removed",
        icon: "email",
        message: (activity, that) => that.$t("notification.mailAdressRemoved"),
        onClick: (activity, that) => {
            that.$router.push("/mails");
        },
    },
    MAIL_WAS_SENT: {
        id: "mail-was-sent",
        icon: "email",
        message: (activity, that) => that.$t("notification.mailWasSent"),
        onClick: (activity, that) => {
            that.$router.push("/mails");
        },
    },

    CONTENT_ADDED: {
        id: "content-added",
        icon: "inventory_2",
        message: (activity, that) =>
            that.$t("notification.contentAdded", {
                content: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/templates");
        },
    },
    CONTENT_REMOVED: {
        id: "content-removed",
        icon: "inventory_2",
        message: (activity, that) =>
            that.$t("notification.contentRemoved", {
                content: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/templates");
        },
    },

    ROLE_ADDED: {
        id: "role-added",
        icon: "extension",
        message: (activity, that) =>
            that.$t("notification.roleAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                role: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/roles");
        },
    },
    ROLE_REMOVED: {
        id: "role-removed",
        icon: "extension",
        message: (activity, that) =>
            that.$t("notification.roleRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                role: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/roles");
        },
    },

    DEPARTMENT_ADDED: {
        id: "department-added",
        icon: "apartment",
        message: (activity, that) =>
            that.$t("notification.departmentAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                department: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/departments");
        },
    },
    DEPARTMENT_REMOVED: {
        id: "department-removed",
        icon: "apartment",
        message: (activity, that) =>
            that.$t("notification.departmentRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                department: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/departments");
        },
    },

    TAGS_ADDED: {
        id: "tags-added",
        icon: "style",
        message: (activity, that) =>
            that.$t("notification.tagAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                tag: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/tags");
        },
    },
    TAGS_REMOVED: {
        id: "tags-removed",
        icon: "style",
        message: (activity, that) =>
            that.$t("notification.tagRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                tag: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/tags");
        },
    },

    TRIGGER_ADDED: {
        id: "trigger-added",
        icon: "notifications",
        message: (activity, that) =>
            that.$t("notification.triggerAdded", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/triggers");
        },
    },
    TRIGGER_REMOVED: {
        id: "trigger-removed",
        icon: "notifications",
        message: (activity, that) =>
            that.$t("notification.triggerRemoved", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/triggers");
        },
    },
    TRIGGER_UPDATED: {
        id: "trigger-updated",
        icon: "notifications",
        message: (activity, that) =>
            that.$t("notification.triggerUpdated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/triggers");
        },
    },

    WELCOME_MESSAGE_ADDED: {
        id: "welcome-message-added",
        icon: "send_time_extension",
        message: (activity, that) =>
            that.$t("notification.welcomeMessageAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                welcome: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/system-messages");
        },
    },
    WELCOME_MESSAGE_REMOVED: {
        id: "welcome-message-removed",
        icon: "assignment_ind",
        message: (activity, that) =>
            that.$t("notification.welcomeMessageRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                welcome: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/system-messages");
        },
    },

    CUSTOMER_GROUP_ADDED: {
        id: "customer-group-added",
        icon: "groups",
        message: (activity, that) =>
            that.$t("notification.customerGroupAdded", {
                group: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/whatsapp-business-api");
        },
    },
    CUSTOMER_GROUP_REMOVED: {
        id: "customer-group-removed",
        icon: "groups",
        message: (activity, that) =>
            that.$t("notification.customerGroupRemoved", {
                group: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/whatsapp-business-api");
        },
    },
    CUSTOMER_GROUP_UPDATED: {
        id: "customer-group-updated",
        icon: "groups",
        message: (activity, that) =>
            that.$t("notification.customerGroupUpdated", {
                group: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/whatsapp-business-api");
        },
    },

    WEBHOOK_ADDED: {
        id: "webhook-added",
        icon: "webhook",
        message: (activity, that) =>
            that.$t("notification.webhookAdded", {
                user1: that.$_.get(activity, "actorUser.name"),
                user2: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/webhook");
        },
    },
    WEBHOOK_REMOVED: {
        id: "webhook-removed",
        icon: "webhook",
        message: (activity, that) =>
            that.$t("notification.webhookRemoved", {
                user1: that.$_.get(activity, "actorUser.name"),
                user2: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/webhook");
        },
    },

    CONTACT_PROP_ADDED: {
        id: "contact-prop-added",
        icon: "connect_without_contact",
        message: (activity, that) =>
            that.$t("notification.contactPropAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                prop: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("visitor-attribute", that);
        },
    },
    CONTACT_PROP_REMOVED: {
        id: "contact-prop-removed",
        icon: "connect_without_contact",
        message: (activity, that) =>
            that.$t("notification.contactPropRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                prop: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("visitor-attribute", that);
        },
    },

    INVOICE_CREATED: {
        id: "invoice-created",
        icon: "featured_play_list",
        message: (activity, that) => that.$t("notification.invoiceCreated", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            that.$router.push("/billing");
        },
    },
    PLAN_STARTED: {
        id: "plan-started",
        icon: "featured_play_list",
        message: (activity, that) => {
            if (that.$_.get(activity, "payload.details")) {
                return that.$t("notification.planStartedAgent", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    details: that.$_.get(activity, "payload.details"),
                });
            } else if (that.$_.get(activity, "payload.detailsChatbot")) {
                return that.$t("notification.planStartedChatbot", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    chatbot: that.$_.get(activity, "payload.detailsChatbot"),
                });
            } else if (that.$_.get(activity, "payload.detailsWp")) {
                return that.$t("notification.planStartedWhatsapp", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    whatsapp: that.$_.get(activity, "payload.detailsWp"),
                });
            } else if (that.$_.get(activity, "payload.detailWpApi")) {
                return that.$t("notification.planStartedWhatsappApi", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    whatsappApi: that.$_.get(activity, "payload.detailWpApi"),
                });
            }
        },
        onClick: (activity, that) => {
            that.$router.push("/billing");
        },
    },
    PLAN_CANCELED: {
        id: "plan-canceled",
        icon: "featured_play_list",
        message: (activity, that) => {
            if (that.$_.get(activity, "payload.details")) {
                return that.$t("notification.planCanceledAgent", {
                    user: getActorName(activity),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    details: that.$_.get(activity, "payload.details"),
                });
            } else if (that.$_.get(activity, "payload.detailsChatbot")) {
                return that.$t("notification.planCanceledChatbot", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    chatbot: that.$_.get(activity, "payload.detailsChatbot"),
                });
            } else if (that.$_.get(activity, "payload.detailsWp")) {
                return that.$t("notification.planCanceledWhatsapp", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    whatsapp: that.$_.get(activity, "payload.detailsWp"),
                });
            } else if (that.$_.get(activity, "payload.detailWpApi")) {
                return that.$t("notification.planCanceledWhatsappApi", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    whatsappApi: that.$_.get(activity, "payload.detailWpApi"),
                });
            }
        },
        onClick: (activity, that) => {
            that.$router.push("/billing");
        },
    },
    INVOICE_PAYMENT_RECEIVED: {
        id: "invoice-payment-received",
        icon: "featured_play_list",
        message: (activity, that) => that.$t("notification.invoicePaymentReceived", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            that.$router.push("/billing");
        },
    },
    INVOICE_PAYMENT_FAILED: {
        id: "invoice-payment-failed",
        icon: "featured_play_list",
        message: (activity, that) => that.$t("notification.invoicePaymentFailed", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            that.$router.push("/billing");
        },
    },
    INVOICE_REFUNDED: {
        id: "invoice-refunded",
        icon: "featured_play_list",
        message: (activity, that) => that.$t("notification.invoiceRefunded", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            that.$router.push("/billing");
        },
    },
    PAYMENT_METHOD_ADDED: {
        id: "payment-method-added",
        icon: "featured_play_list",
        message: (activity, that) =>
            that.$t("notification.paymentMethodAdded", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/billing");
        },
    },
    BILLING_ADDRESS_UPDATED: {
        id: "billing-address-updated",
        icon: "featured_play_list",
        message: (activity, that) =>
            that.$t("notification.billingAddressUpdated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/billing");
        },
    },

    TASK_WORKFLOW_CREATED: {
        id: "task-workflow-created",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskWFlowCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                Wflow: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/tasks");
        },
    },
    TASK_WORKFLOW_DELETED: {
        id: "task-workflow-deleted",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskWorkflowDeleted", {
                user: that.$_.get(activity, "actorUser.name"),
                workflow: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/tasks");
        },
    },
    TASK_CREATED: {
        id: "task-created",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                task: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push(`/tasks?taskId=${that.$_.get(activity, "payload.id")}&workflow=${that.$_.get(activity, "payload.workflowId")}&type=kanban`);
        },
    },
    TASK_DELETED: {
        id: "task-deleted",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskDeleted", {
                user: that.$_.get(activity, "actorUser.name"),
                task: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push(`/tasks?workflow=${that.$_.get(activity, "payload.workflowId")}&type=kanban`);
        },
    },
    TASK_STAGE_CHANGED: {
        id: "task-stage-changed",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskStageChanged", {
                user: that.$_.get(activity, "actorUser.name"),
                task: that.$_.get(activity, "payload.name"),
                oldStage: that.$_.get(activity, "payload.oldStage"),
                newStage: that.$_.get(activity, "payload.newStage"),
            }),
        onClick: (activity, that) => {
            that.$router.push(`/tasks?taskId=${that.$_.get(activity, "payload.id")}&workflow=${that.$_.get(activity, "payload.workflowId")}&type=kanban`);
        },
    },
    TASK_ASSIGNED_TO_USER: {
        id: "task-assigned-to-user",
        icon: "add_task",
        message: (activity) => {
            let message = activity.actorUser.name + " kullanıcısı: ";
            let assignees = activity.payload.assignees;
            for (let i = 0; i < assignees.length; i++) {
                message += assignees[i].name + ", ";
            }
            message += '"' + activity.payload.taskTitle + '" adlı göreve atadı.';
            return message;
        },
        onClick: (activity, that) => {
            that.$router.push(`/tasks?taskId=${that.$_.get(activity, "payload.id")}&workflow=${that.$_.get(activity, "payload.workflowId")}&type=kanban`);
        },
    },

    TICKET_ASSIGNED_TO_USER: {
        id: "ticket-assigned-to-user",
        icon: "local_activity",
        message: (activity, that) =>
            that.$t("notification.ticketAssigned", {
                user1: getActorName(activity),
                user2: that.$_.get(activity, "payload.assignedUserName"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/ticket");
        },
    },

    CHATBOT_CREDIT_LOW: {
        id: "chatbot-credit-low",
        icon: "report",
        message: () => `Chatbot credit is almost over. %90 ChatBot Credit Used.`,
    },
    CHATBOT_CREDIT_DONE: {
        id: "Fchatbot-credit-done",
        icon: "disc_full",
        message: () => `Chatbot session is done.`,
    },
    SYSTEM_STATUS: {
        id: "system-status",
        icon: "update",
        message: (activity) => `System status is ${_.get(activity, "payload.status") === true ? "Online" : "Offline"}.`,
    },
    WHATSAPP_CREDIT_LOW: {
        id: "whatsapp-credit-low",
        message: (activity) => `Whatsapp credit has dropped to ${_.get(activity, "payload.balance")}₺!`,
    },
    RESERVATION_CREATED_PLAN: {
        id: "reservation-created-plan",
        icon: "today",
        message: (activity, that) =>
            that.$t("notification.reservationCreatedPlan", {
                name: that.$_.get(activity, "actorUser.name"),
                title: that.$_.get(activity, "payload.title"),
                date: that.$_.get(activity, "payload.customProgramDates.startDate"),
            }),
    },
    RESERVATION_UPDATED_PLAN: {
        id: "reservation-updated-plan",
        icon: "event_repeat",
        message: (activity, that) =>
            that.$t("notification.reservationUpdatedPlan", {
                name: that.$_.get(activity, "actorUser.name"),
                title: that.$_.get(activity, "payload.title"),
            }),
    },
    RESERVATION_DELETED_PLAN: {
        id: "reservation-deleted-plan",
        icon: "event_busy",
        message: (activity, that) =>
            that.$t("notification.reservationDeletedPlan", {
                name: that.$_.get(activity, "actorUser.name"),
                title: that.$_.get(activity, "payload.title"),
            }),
    },
    RESERVATION_CREATED: {
        id: "reservation-created",
        icon: "today",
        message: (activity, that) =>
            that.$t("notification.reservationCreated", {
                name: that.$_.get(activity, "payload.userName"),
                visitor: that.$_.get(activity, "payload.visitorFullname"),
                date: that.$_.get(activity, "payload.date"),
            }),
    },
    RESERVATION_UPDATED: {
        id: "reservation-updated",
        icon: "event_repeat",
        message: (activity, that) => `Reservation Updated`,
    },
    RESERVATION_DELETED: {
        id: "reservation-deleted",
        icon: "event_busy",
        message: (activity, that) =>
            that.$t("notification.reservationDeleted", {
                name: that.$_.get(activity, "payload.userName"),
                visitor: that.$_.get(activity, "payload.visitorFullname"),
                date: that.$_.get(activity, "payload.date"),
            }),
    },
};

export default ActivityTypes;
